import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { LocalStorageCache } from 'src/services/cache/LocalStorageCache';
import type { CacheStore } from 'src/stores/BrowserCache';
import { BrowserCacheContext } from 'src/stores/BrowserCache';
import type { ProviderProps } from 'src/types/provider';

export const initTokens = {
  search: undefined,
  suggest: undefined,
  recommend: {
    detailPageView: undefined,
    shoppingCartPageView: undefined
  }
};

const shopId = new LocalStorageCache('shopId', undefined);
const checkedFavList = new LocalStorageCache('checkedFavList', null);
const couponHistoryId = new LocalStorageCache('couponHistoryId', NaN);
const savedReviewFormData = new LocalStorageCache('savedReviewFormData,', null);
const pinchOutPopupShownDate = new LocalStorageCache('pinchOutPopupShownDate,', null);
const cachedAttributionTokens = new LocalStorageCache('cachedAttributionTokens', initTokens);

const cacheStore: CacheStore = {
  shopId,
  checkedFavList,
  couponHistoryId,
  savedReviewFormData,
  pinchOutPopupShownDate,
  cachedAttributionTokens
};

const isRelevantPage = (url: string): boolean =>
  url.includes('/search') || url.includes('/products') || url.includes('/cart');

const BrowserProvider: React.FC<ProviderProps> = ({ children }) => {
  const router = useRouter();

  useEffect(() => {
    cachedAttributionTokens?.set(initTokens);
  }, []);

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (!isRelevantPage(url)) {
        cachedAttributionTokens?.set(initTokens);
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);
  return <BrowserCacheContext.Provider value={cacheStore}>{children}</BrowserCacheContext.Provider>;
};

export { BrowserProvider };
